import { Component, OnInit } from '@angular/core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { MessageService } from '@services/message.service';
import { RestService } from '@services/rest.service';
import { LoaderComponent } from 'src/app/components/loader/loader.component';

@Component({
  selector: 'app-funzionalita',
  templateUrl: './funzionalita.component.html',
  styleUrls: ['./funzionalita.component.scss'],
})
export class FunzionalitaComponent implements OnInit {
  constructor(private rest: RestService, private message: MessageService) { }

  public faChevronDown = faChevronDown;
  public faChevronUp = faChevronUp;

  showPrima = false;
  showSeconda = false;
  showTerza = false;
  showQuarta = false;
  showQuinta = false;
  showSesta = false;
  showSettima = false;
  showOttava = false;
  settingFreeUser: any = null;

  ngOnInit(): void {
    LoaderComponent.isLoading = true;
    this.rest.get(`abbonamento/user/features/free`).subscribe((res: any) => {
      this.settingFreeUser = res;
      LoaderComponent.isLoading = false;
    });
  }

  saveChanges() {
    LoaderComponent.isLoading = true;
    this.rest
      .post(`abbonamento/admin/features/free`, this.settingFreeUser)
      .subscribe((res: any) => {
        LoaderComponent.isLoading = false;
        this.showMessage('Modifica avvenuta con successo', 'success');
      });
  }
  showMessage(message: string, status: string) {
    this.message.showMessage(message, status);
  }

  changeCheckValue(variable: string, event: any) {
    this.settingFreeUser[variable] =
      event.target.value == 'true' ? true : false;
  }

  changeLimitQuestions(event: any) {
    this.settingFreeUser.limiteNumeroDomande = event.target.value
      ? parseInt(event.target.value)
      : 0;
  }

  v1() {
    this.showPrima = !this.showPrima;
  }

  v2() {
    this.showSeconda = !this.showSeconda;
  }

  v3() {
    this.showTerza = !this.showTerza;
  }

  v4() {
    this.showQuarta = !this.showQuarta;
  }

  v5() {
    this.showQuinta = !this.showQuinta;
  }

  v6() {
    this.showSesta = !this.showSesta;
  }

  v7() {
    this.showSettima = !this.showSettima;
  }

  v8() {
    this.showOttava = !this.showOttava;
  }
}
